import { Users, Settings2, UserCheck, BadgeCheck, Languages, Car, Star } from "lucide-react";
import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { useLang, speaksLang } from "@/context/LangContext";


export function CarCard({ car, onBook }) {
  const { t, money, tr } = useLang();
  return (
    <div data-testid={`car-rental-card-${car.slug}`} className="catalog-card group overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-xl">
      <div className="aspect-[16/10] overflow-hidden bg-slate-100"><ResponsiveImage src={car.image} alt={car.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
      <div className="p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-[#D97706]">{car.type}</p>
        <h3 className="mt-1 text-lg font-bold">{car.name}</h3>
        <div className="mt-3 flex flex-wrap gap-3 text-sm text-slate-600">
          <span className="flex items-center gap-1"><Users className="h-4 w-4" />{car.seats} {t("seats")}</span>
          <span className="flex items-center gap-1"><Settings2 className="h-4 w-4" />{car.transmission}</span>
          <span className="flex items-center gap-1 text-emerald-700"><UserCheck className="h-4 w-4" />{t("with_driver")}</span>
        </div>
        <div className="catalog-price-actions mt-5 flex items-end justify-between gap-3">
          <p data-testid={`car-price-${car.slug}`} className="catalog-price text-xl font-extrabold">{money(car.price)}<span className="text-sm font-medium text-slate-500">{t("per_day")}</span></p>
          <button data-testid={`car-rent-now-button-${car.slug}`} onClick={() => onBook({ type: "car", slug: car.slug, name: car.name, price: car.price })}
            className="rounded-full bg-[#064E3B] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#047857]">{t("rent_now")}</button>
        </div>
      </div>
    </div>
  );
}

export function GuideCard({ g, onBook }) {
  const { t, money, lang } = useLang();
  const native = lang !== "id" && speaksLang(g, lang);
  return (
    <div data-testid={`driver-guide-card-${g.slug}`} className={`catalog-card relative rounded-3xl border bg-white p-5 shadow-sm transition-shadow hover:shadow-xl ${native ? "border-[#FBBF24] ring-2 ring-[#FBBF24]/40" : "border-slate-200"}`}>
      {native && <span data-testid={`guide-native-badge-${g.slug}`} className="absolute -top-3 right-5 rounded-full bg-[#FBBF24] px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-slate-900 shadow">{t("speaks_your_lang")}</span>}
      <div className="guide-identity flex items-center gap-4">
        <ResponsiveImage src={g.photo} sizes="80px" alt={g.name} loading="lazy" className="h-20 w-20 shrink-0 rounded-2xl object-cover" />
        <div>
          <p className="flex items-center gap-1 font-bold text-slate-900">{g.name}<BadgeCheck className="h-4 w-4 text-sky-500" /></p>
          <p className="text-sm text-[#D97706] font-semibold">{t(`role_${g.role}`)}</p>
          <p className="mt-1 flex items-center gap-1 text-sm"><Star className="h-4 w-4 fill-amber-400 text-amber-400" /><b>{g.rating}</b><span className="text-slate-500">· {g.trips} {t("trips")}</span></p>
        </div>
      </div>
      <div className="mt-4 space-y-1.5 text-sm text-slate-600">
        <p className="flex items-center gap-2"><Languages className="h-4 w-4" />{g.languages.join(", ")}</p>
        <p className="flex items-center gap-2"><Car className="h-4 w-4" />{t("vehicle")}: {g.vehicle} · {g.years} {t("years_exp")}</p>
      </div>
      <div className="catalog-price-actions mt-5 flex items-end justify-between gap-3">
        <p data-testid={`guide-price-${g.slug}`} className="catalog-price text-lg font-extrabold">{money(g.price)}<span className="text-sm font-medium text-slate-500">{t("per_day")}</span></p>
        <button data-testid={`guide-book-now-button-${g.slug}`} onClick={() => onBook({ type: "guide", slug: g.slug, name: g.name, price: g.price })}
          className="rounded-full bg-slate-900 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-slate-700">{t("hire_now")}</button>
      </div>
    </div>
  );
}
